<template>
  <div>
    <v-card fluid>
      <v-tooltip top>
        <template slot="activator">
          <v-btn
            fixed
            dark
            fab
            bottom
            right
            color="lime"
            class="mr-3 mb-3"
            @click.native="fab_button"
            :disabled="disabled"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Click to save the change you have made</span>
      </v-tooltip>

      <v-card-title>
        <v-toolbar dark color="lime">
          <!--<v-btn icon dark @click="dialog_osp = false">
              <v-icon>close</v-icon>
          </v-btn>-->
          <v-avatar size="48">
            <img src="@/assets/favicon.png" alt="avatar" />
          </v-avatar>
          <v-spacer></v-spacer>
          <v-toolbar-title
            >PROFESSSIONAL UPGRADING EXAMINATION APPLICATION
            CORRECTION</v-toolbar-title
          >
          <!--<v-spacer></v-spacer>
        <v-toolbar-items>
         <v-btn dark flat @click.native="saveEdit">SAVE</v-btn>
          </v-toolbar-items>-->
        </v-toolbar>
      </v-card-title>
      <v-alert :value="error_alert_value" type="error"
        >Please fix all errors before saving. Ensure that the required input on
        the form is filled correctly</v-alert
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-progress-linear
              :indeterminate="true"
              color="lime"
              v-if="sending"
            ></v-progress-linear>
            <v-flex xs12 sm12 md12 class="mt-4">
              <h4>
                Only upload attachments that you did not upload correctly as
                stated in the email sent to you. Leave the rest empty.
              </h4>
            </v-flex>
            <v-flex xs12 md12>
              <h4>Training Institution Admission Letter</h4>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Click to upload"
                v-model="file_name_a"
                :error-messages="errors.file_a"
                @click="onPickFileA"
                color="lime"
                prepend-icon="attach_file"
                append-outer-icon="clear"
                @click:append-outer="clearA"
                readonly
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="fileInputA"
                id="fileInputA"
                @change="onFilePickedA"
              />
            </v-flex>
            <v-flex xs12 md12>
              <h4>K.C.S.E Certificate</h4>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Click to upload"
                v-model="file_name_k"
                :error-messages="errors.file_k"
                @click="onPickFileK"
                color="lime"
                prepend-icon="attach_file"
                append-outer-icon="clear"
                @click:append-outer="clearK"
                readonly
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="fileInputK"
                id="fileInputK"
                @change="onFilePickedK"
              />
            </v-flex>
            <v-flex xs12 md12>
              <h4>Student Agreement Form</h4>
              <div>
                This form is supposed to be downloaded, physically filled and
                scanned before uploading. Follow this link to download it
                <a
                  href="https://www.kndi.institute/exams/student_agreement_form.pdf"
                  target="_blank"
                  >click here</a
                >
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Click to upload"
                v-model="file_name_s"
                :error-messages="errors.file_s"
                @click="onPickFileS"
                color="lime"
                prepend-icon="attach_file"
                append-outer-icon="clear"
                @click:append-outer="clearS"
                readonly
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="fileInputS"
                id="fileInputS"
                @change="onFilePickedS"
              />
            </v-flex>
            <!--
              Added 29 Sep - correct()'s identification_document branch has always
              existed server-side, but no client control ever sent it. OPTIONAL,
              matching the registration form: existing applicants are never chased
              for it, so this only offers the chance to add one, never demands it.
            -->
            <v-flex xs12 md12>
              <h4>National ID or Birth Certificate (optional)</h4>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Click to upload, if you have a scanned copy"
                v-model="file_name_id"
                :error-messages="errors.file_id"
                @click="onPickFileId"
                color="lime"
                prepend-icon="attach_file"
                append-outer-icon="clear"
                @click:append-outer="clearId"
                readonly
              ></v-text-field>
              <input
                type="file"
                style="display: none"
                ref="fileInputId"
                id="fileInputId"
                @change="onFilePickedId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <!--<v-spacer></v-spacer>
      <v-btn color="red darken-1" flat @click.native="closeCreate">Cancel</v-btn>
      <v-btn
        color="lime darken-1"
        flat
        @click.native="saveEdit"
        :disabled="disabled"
        >Save</v-btn>-->
      </v-card-actions>
    </v-card>
    <v-dialog v-model="downloaded" persistent width="300">
      <v-card color="lime" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :multi-line="mode"
      :right="x"
      :top="y"
      :timeout="timeout"
    >
      {{ snackbar_text }}
      <v-btn color="lime" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import swal from "sweetalert2"
import {
  upgradingExamApplicationCorrectUrl,
  upgradingExamStepperDataTokenUrl
} from "@/config"
export default {
  data() {
    return {
      menu1: false,
      dialog_add: false,
      show_container_can: false,
      snackbar: false,
      snackbar_text: "",
      y: "",
      x: "",
      mode: "",
      timeout: 6000,
      menu: false,
      disabled: false,
      model: {},
      downloaded: false,
      error_alert_value: false,
      examination_status: [],
      internship_centers: [],
      training_institutions: [],
      exam_papers: [],
      exam_periods: [],
      counties: [],
      exam_centers: [],
      gender: [],
      entries: [],
      file_name_a: "",
      file_name_k: "",
      file_name_s: "",
      file_name_id: "",
      file_a: "",
      file_k: "",
      file_s: "",
      file_id: "",
      errors: {},
      sending: false,
      courses: [],
      sec_schools: [],
      counties: [],
      countries: [],
      e_qualifications: [],
      gender: [],
      registered: ""
    }
  },
  beforeMount() {
    if (this.$route.params.token != "") {
      this.fetchData()
      this.downloaded = true
    } else {
      swal({
        title: "Unauthorized",
        text: "You are not authorized to use this service",
        type: "warning",
        confirmButtonColor: "#cddc39",
        confirmButtonText: "OK"
      })
      this.$router.push({ name: "register" })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!window.setIntervalConfirm) {
      next()
    } else {
      clearInterval(setIntervalConfirm)
      next()
    }
  },
  mounted() {
    var counter = 0
    var vm = this
    window.setIntervalConfirm = setInterval(function() {
      counter += 1

      /*if (!vm.counties.length) {
        vm.fetchData()
      }*/

      if (counter === 3) {
        clearInterval(setIntervalConfirm)
      }
    }, 60000)
  },
  methods: {
    fetchData() {
      var vm = this
      const data = {
        id: vm.$route.params.token
      }
      axios
        .post(upgradingExamStepperDataTokenUrl, data)
        .then(function(response) {
          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          } else {
            vm.downloaded = false
          }
        })
        .catch(function(error) {
          console.log(error.message)
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    fab_button() {
      var vm = this
      swal({
        title: "Confirm",
        text: "Do you want to submit the form",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#CDDC39",
        cancelButtonColor: "#F44336",
        confirmButtonText: "Proceed",
        cancelButtonText: "Cancel"
      }).then(result => {
        if (result.value) {
          vm.saveEdit()
        } else if (
          // Read more about handling dismissals
          result.dismiss === "cancel"
        ) {
          swal({
            title: "Cancelled",
            text: "form was not submitted",
            type: "error",
            confirmButtonColor: "#cddc39",
            confirmButtonText: "OK"
          })
        }
      })
    },
    saveEdit() {
      var vm = this
      vm.sending = true
      vm.disabled = true
      vm.downloaded = true
      var data = {
        token: vm.$route.params.token,
        secondary_certificate: vm.file_k,
        student_agreement_form: vm.file_s,
        admission_letter: vm.file_a
      }
      // Optional, so it is only added to the payload when something was picked -
      // correct() checks isset($request->identification_document), so leaving the
      // key out entirely is what "did not choose to supply this" means to it.
      if (vm.file_id != "") {
        data.identification_document = vm.file_id
      }

      const options = {
        method: "POST",
        data: data,
        url: upgradingExamApplicationCorrectUrl
      }
      vm.downloaded = true
      axios(options)
        .then(function(response) {
          if (response.data.saved) {
            swal({
              title: "Submitted",
              text: "Corrected successfully",
              type: "success",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.unauthorized) {
            swal({
              title: "Unauthorized",
              text: "You are not authorized to use this service",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
            vm.$router.push({ name: "upgrading-examination-register" })
          }
          if (response.data.duplicate) {
            swal({
              title: "Duplicate",
              text:
                "This student has already undertaken first professional examination",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          if (response.data.file_error_secondary_certificate) {
            swal({
              title: "File Error",
              text:
                "Only jpeg, png or pdf format required for secondary school certificate",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          if (response.data.file_error_admission_letter) {
            swal({
              title: "File Error",
              text:
                "Only jpeg, png or pdf format required for university/college admission letter",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          if (response.data.file_error_student_agreement_form) {
            swal({
              title: "File Error",
              text:
                "Only jpeg, png or pdf format required for student agreement form",
              type: "warning",
              confirmButtonColor: "#cddc39",
              confirmButtonText: "OK"
            })
          }
          vm.sending = false
          vm.disabled = false
          vm.downloaded = false
        })
        .catch(function(error) {
          console.log(error)
          if (error.response.data) {
            Vue.set(vm.$data, "errors", error.response.data)
            vm.disabled = false
            vm.error_alert_value = true
            vm.downloaded = false
          }
          if (error.message == "Network Error") {
            vm.snackbar_text =
              "we have detected a slow internet connection! It may interfer with the responsiveness of the KNDI OSP"
            vm.snackbar = true
            vm.x = "right"
            vm.y = "top"
            vm.mode = "multi-line"
          }
        })
    },
    clearA() {
      var vm = this
      vm.$refs.fileInputA.value = ""
      vm.file_name_a = ""
      vm.file_a = ""
    },
    clearK() {
      var vm = this
      vm.$refs.fileInputK.value = ""
      vm.file_name_k = ""
      vm.file_k = ""
    },
    clearS() {
      var vm = this
      vm.$refs.fileInputS.value = ""
      vm.file_name_s = ""
      vm.file_s = ""
    },
    onPickFileA() {
      var vm = this
      vm.$refs.fileInputA.click()
    },
    onFilePickedA(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.file_a = e.target.result
        vm.file_name_a = file.name
        //console.log(vm.file_name_c)
      }
    },
    onPickFileK() {
      var vm = this
      vm.$refs.fileInputK.click()
    },
    onFilePickedK(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.file_k = e.target.result
        vm.file_name_k = file.name
        //console.log(vm.file_name_c)
      }
    },
    onPickFileS() {
      var vm = this
      vm.$refs.fileInputS.click()
    },
    onFilePickedS(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.file_s = e.target.result
        vm.file_name_s = file.name
        //console.log(vm.file_name_c)
      }
    },
    clearId() {
      var vm = this
      vm.$refs.fileInputId.value = ""
      vm.file_name_id = ""
      vm.file_id = ""
    },
    onPickFileId() {
      var vm = this
      vm.$refs.fileInputId.click()
    },
    onFilePickedId(e) {
      var vm = this
      var file = e.target.files[0]
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = e => {
        vm.file_id = e.target.result
        vm.file_name_id = file.name
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/upgrading-exam-correct.vue